import React from 'react';

import { StyleSheet } from 'react-native';

import Link from 'components/link';
import { Box, Typography } from 'components/ui';
import type { BoxProps, TypographyProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { getDesignToken, primitive, spacing } from 'styles/constants';

export const MenuNavigationTabLink = Link.withConfig<{ active?: boolean }>(p => ({
  flexGrow: 1,
  isUnderlined: false,
  fontFamily: 'body',
  textAlign: 'center',
  textTransform: 'none',
  maxWidth: 'full',
  borderBottomWidth: 2,
  paddingX: 2,
  justifyContent: 'center',
  alignItems: 'center',
  margin: 0,
  paddingY: '$4',

  _focus: {
    borderBottomColor: {
      base: p.active ? getDesignToken('color-tertiary') : 'transparent',
      md: p.active ? primitive.$bbqBrown : 'transparent',
    },
  },

  borderBottomColor: p.active ? getDesignToken('color-tertiary') : 'transparent',
  _text: {
    marginBottom: {
      md: 0,
    },
  },
}));

type MenuNavigationTabTextProps = TypographyProps & {
  active?: boolean;
};

export const MenuNavigationTabText = ({ active, style, ...props }: MenuNavigationTabTextProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return React.createElement(Typography, {
    ...props,
    color: getDesignToken('color-tertiary'),
    fontFamily: active ? 'heading' : 'body',
    fontSize: isDesktop ? 'sm' : props.fontSize,
    lineHeight: isDesktop ? 'md' : props.lineHeight,
    style: [styles.tabText, style],
  });
};

export const MenuNavigationTabBorderBottom = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.borderBottom, style],
  });

const styles = StyleSheet.create({
  borderBottom: {
    backgroundColor: primitive.$blackOpacity10,
    bottom: 0,
    height: spacing.$0_5,
    position: 'absolute',
    width: '100%',
  },
  tabText: {
    margin: 0,
    padding: 0,
  },
});
